import { EnvironmentProviders, Provider } from '@angular/core';
import { FP_CORRELATION_TAB_CONNECT_SERVICES } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/providers/fp-correlation-tab-connect-services.token';
import { FpCorrelationGraphChartService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph-chart.service';
import { FpCorrelationGraphConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph-connect.service';
import { FpCorrelationGraphExportService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph-export.service';
import { FpCorrelationGraphStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-graph/services/fp-correlation-graph/fp-correlation-graph.store';

export function fpCorrelationGraphProvider(): (EnvironmentProviders | Provider)[] {
  return [
    FpCorrelationGraphChartService,
    FpCorrelationGraphExportService,
    FpCorrelationGraphStore,
    FpCorrelationGraphConnectService,
    {
      provide: FP_CORRELATION_TAB_CONNECT_SERVICES,
      useExisting: FpCorrelationGraphConnectService,
      multi: true,
    },
  ];
}
